import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {
  private eventSubject = new Subject<string>();
  event$ = this.eventSubject.asObservable();

  emitEvent(data: string) {
    this.eventSubject.next(data);
  }
}